import React from "react";
import logo from "../images/logo.png";
import "./LoadingAnimations.css";

const SessionLoadingState = ({ message = "Loading your session..." }) => {
	return (
		<section className="flex flex-col justify-center mt-1 mb-4 md:mx-smPagePadding md:px-mdPagePadding lg:mx-lgPagePadding lg:px-lgPagePadding xl:mx-xlPagePadding xl:px-xlPagePadding">
			{/* Logo */}
			<div className="flex flex-col justify-center items-center float-animation">
				<img src={logo} alt="logo" className="w-40 h-auto object-contain" />
			</div>

			{/* Skeleton UI for Session Instructions */}
			<div className="mx-smPagePadding flex flex-col justify-center items-start text-start py-3 px-4 rounded-primary border border-gray-200 bg-gray-50 slide-in-down animate-delay-200">
				<div className="h-6 skeleton-shimmer rounded w-32 mb-4"></div>
				<div className="px-3 py-2 border-l-2 border-gray-300 mb-2 w-full">
					<div className="space-y-2">
						<div className="h-4 skeleton-shimmer rounded w-full"></div>
						<div className="h-4 skeleton-shimmer rounded w-3/4 animate-delay-100"></div>
						<div className="h-4 skeleton-shimmer rounded w-5/6 animate-delay-200"></div>
						<div className="h-4 skeleton-shimmer rounded w-2/3 animate-delay-300"></div>
					</div>
				</div>
			</div>

			{/* Skeleton for Booth Details */}
			<div className="border-t border-b border-gray-200 py-5 mx-smPagePadding flex flex-col justify-center items-center mb-9 mt-5 slide-in-down animate-delay-300">
				<div className="flex justify-between items-center mb-2 w-full">
					<div className="flex gap-8 justify-center text-textSecondary w-full">
						<div className="h-4 skeleton-shimmer rounded w-24"></div>
						<div className="h-4 skeleton-shimmer rounded w-20 animate-delay-100"></div>
					</div>
				</div>
				<div className="flex items-center gap-3 text-textSecondary">
					<div className="h-4 skeleton-shimmer rounded w-32"></div>
					<div className="h-4 w-px bg-gray-300"></div>
					<div className="h-4 skeleton-shimmer rounded w-16 animate-delay-200"></div>
				</div>
			</div>

			{/* Skeleton for QR Code */}
			<div className="mx-smPagePadding flex flex-col justify-center items-center rounded-primary slide-in-down animate-delay-500">
				<div className="w-44 h-44 skeleton-shimmer rounded-lg flex items-center justify-center">
					<div className="w-32 h-32 bg-gray-400 rounded opacity-50 animate-pulse"></div>
				</div>
			</div>

			{/* Skeleton for Cancel Button */}
			<div className="mx-smPagePadding bottom-0 left-0 right-0 mt-6 flex flex-col justify-center items-center py-4 md:px-16 md:mt-16 lg:px-20 lg:mt-20 animate-pulse">
				<div className="h-12 bg-gray-300 rounded-secondary w-full mb-2"></div>
				<div className="h-4 bg-gray-300 rounded w-48"></div>
			</div>

			{/* Subtle background animation */}
			<div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
				<div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-50 rounded-full opacity-20 animate-pulse"></div>
				<div
					className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-50 rounded-full opacity-20 animate-pulse"
					style={{ animationDelay: "1s" }}
				></div>
			</div>
		</section>
	);
};

export default SessionLoadingState;
